/* --------------------------------------------------------------------------------------
   printActionBar.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const printActionBarComponent = {
  template: `
  <div class="xrx-action-bar {{vm.getPrimaryBackground()}}">
    <button xw-button class="xrx-action-bar-button-left" glyph="user" ng-click="vm.cancel()">{{vm.sessionDataService.username}}</button>
    <div class="xrx-action-bar-label">{{vm.title}}</div>
    <button xw-button class="xrx-action-bar-button-right" glyph="print" ng-click="vm.ok()">{{ 'PRINT' | translate }}</button>
  </div>
  `,
  controllerAs: 'vm',
  controller: class actionBarCtrl {
    /*@ngInject*/
    constructor(appSettings, sessionDataService) {
      this.sessionDataService = sessionDataService
      this.appSettings = appSettings
    }
    getPrimaryBackground() {
      if (this.background == 'primary')
        return "xrx-background " + this.appSettings.primaryColor
    }
  },
  bindings: {
    title: '@',
    cancel: '&',
    ok: '&',
    disableOk: '<',
    background: '@'
  }
}



// WEBPACK FOOTER //
// ./src/app/print/components/printActionBar.component.js